<template>
  <div class="job-parts container-fluid" v-if="job">
    <div class="job-parts__head row mb-3">
      <div class="job-parts__head__adr col-6">
        <strong>
          {{ job.locations[0].street }},
          {{ `${job.locations[0].postal_code} ${job.locations[0].city}` }} /
          {{
            job.type == app.options.Job.TYPE.servicing
              ? "Serviceauftrag"
              : "Montage"
          }}
        </strong>
      </div>
      <div class="col-6">
        <button
          class="btn btn-primary float-right mb-2"
          @click="showJobTechnicianMessagesWindow()"
        >
          Meldung erfassen
        </button>
      </div>
    </div>
    <div class="job-parts__main pt-2">
      <div class="job-parts__body row" ref="body">
        <div class="job-parts__parts col-auto">
          <h2>Position</h2>

          <ul>
            <li>
              <button :class="{ active: true }">
                {{ preselectedPart ? preselectedPart.location_position : "" }}

                <div v-if="preselectedPart && preselectedPart.report">
                  <img
                    v-if="preselectedPart.report.status == 0"
                    :src="icon('warning-important.svg')"
                  />
                  <img v-else :src="icon('check-circle-green.svg')" />
                </div>
              </button>
            </li>
          </ul>
        </div>

        <div class="job-parts__buttons col-auto">
          <h2>Unterlagen</h2>

          <ul>
            <li>
              <button
                @click="
                  $windows.showFilesWindow(
                    'Dokumente',
                    selectedPartFiles,
                    null,
                    null,
                    'full'
                  )
                "
                :disabled="!partSelected || !selectedPartFiles.length"
              >
                Dokumente
              </button>
            </li>
            <li>
              <button
                @click="showDetails = 'props'"
                :class="{ active: showDetails == 'props' }"
                :disabled="
                  !partSelected ||
                  job.added_manually == 2 ||
                  !partSelected.dimensions ||
                  !partSelected.dimensions.length
                "
              >
                Eigenschaften
              </button>
            </li>
            <li>
              <button
                @click="
                  showDetails = 'fittings';
                  showDetailsCategory = 2;
                "
                :class="{
                  active: showDetails == 'fittings' && showDetailsCategory == 2,
                }"
                :disabled="
                  !partSelected ||
                  !selectedPartFittings[2] ||
                  !selectedPartFittings[2].length
                "
              >
                Beschläge
              </button>
            </li>
            <li>
              <button
                @click="
                  showDetails = 'fittings';
                  showDetailsCategory = 3;
                "
                :class="{
                  active: showDetails == 'fittings' && showDetailsCategory == 3,
                }"
                :disabled="
                  !partSelected ||
                  !selectedPartFittings[3] ||
                  !selectedPartFittings[3].length
                "
              >
                Festteile
              </button>
            </li>
            <li>
              <button
                @click="
                  showDetails = 'fittings';
                  showDetailsCategory = 1;
                "
                :class="{
                  active: showDetails == 'fittings' && showDetailsCategory == 1,
                }"
                :disabled="
                  !partSelected ||
                  !selectedPartFittings[1] ||
                  !selectedPartFittings[1].length
                "
              >
                Türblätter
              </button>
            </li>
            <li>
              <button
                :disabled="!notizen"
                @click="showDetails = 'notizenDetails'"
                :class="{
                  active: showDetails == 'notizenDetails',
                }"
              >
                Notizen
              </button>
            </li>
            <li>
              <button
                @click="
                  showDetails = 'messages';
                  showDetailsCategory = 4;
                "
                :class="{
                  active: showDetails == 'messages' && showDetailsCategory == 4,
                }"
                :disabled="!partSelected || !messages || messages.length == 0"
              >
                Historie
              </button>
            </li>
          </ul>
        </div>

        <div class="job-parts__details col-auto" v-if="showDetails">
          <h2>Details</h2>

          <div v-if="showDetails == 'notizenDetails'">
            <div class="row">
              <div class="col col-12">
                <div class="card">
                  <h2 class="title-sec"><strong>Beschreibung</strong></h2>
                  <div v-html="notizen"></div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="showDetails == 'props'">
            <div class="row">
              <div class="col col-12">
                <div class="card">
                  {{
                    `${partSelected.location_floor} - ${partSelected.location_position}`
                  }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col col-12">
                <div class="card">
                  <h3>Dimensionen</h3>

                  <ul
                    v-if="partSelected.dimensions"
                    class="list-reset list-h job-parts__details__dimensions"
                  >
                    <li
                      v-for="(dimension, index) in partSelected.dimensions"
                      :key="index"
                      class="mr-xl"
                    >
                      {{ dimension.extDesc || dimension.id }}<br />
                      {{
                        `${dimension.strValue || dimension.value} ${
                          dimension.unit ||
                          __(
                            "jobs.components.fittings.list.common.fitting_unit_default"
                          )
                        }`
                      }}
                    </li>
                  </ul>
                  <i v-else>Keine Dimensionen angegeben.</i>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="showDetails == 'messages'">
            <div class="row">
              <div class="col col-12">
                <!-- class="card mb-xs" -->
                <div v-for="message in messages" class="p-0" :key="message.id">
                  <!-- (!message.data.text ? 'hide-collapse-btn' : '') -->
                  <collapsible
                    :class="
                      'checklist-collapsible ' +
                      (!message.data ? 'hide-collapse-btn' : '')
                    "
                    class-head="container-fluid"
                    class-head-inner="row m-0"
                    :close-on-head-click="true"
                  >
                    <template slot="head">
                      <div
                        class="
                          title
                          d-flex
                          justify-content-between
                          w-100
                          row
                          m-0
                        "
                      >
                        <h2 class="col-8 pl-0">
                          {{ dateOutput(message.created_at) }}
                          {{
                            __(
                              `messages.jobs.common.${message.sourceTypeName}.${
                                job.type == app.options.Job.TYPE.servicing &&
                                message.sourceTypeName ==
                                  "job_close_without_text"
                                  ? "service_title"
                                  : "title"
                              }`
                            )
                          }}
                        </h2>

                        <small :class="'date' + ' col-4 pr-0 text-right'"
                          >{{ message.trigger_user.name }}
                          {{ dateOutput(message.updated_at) }}</small
                        >
                      </div>
                    </template>

                    <template slot="body">
                      <template v-if="message.data">
                        <div class="row w-100 pb-3">
                          <div class="col-9">
                            <span v-if="message.context_info.part">
                              {{ message.context_info.part.name }}
                              {{
                                message.data.check_title
                                  ? " | " + message.data.check_title
                                  : ""
                              }}
                              {{ message.data.text ? " | " : "" }}
                              <span
                                class="text"
                                v-html="message.data.text"
                              ></span>
                            </span>
                          </div>
                          <div class="col-3">
                            <!-- <div
                              class=""
                              v-for="(item, index) in messages"
                              :key="index"
                            > -->
                            <div
                              v-for="(img, index2) in message.data.pictures"
                              :key="index2"
                              class="mb-2"
                            >
                              <img :src="img.path" :alt="img.name" v-if="img" />
                              <div v-else class="no-img">
                                <img :src="icon('camera.svg')" />
                              </div>
                            </div>
                            <!-- </div> -->
                          </div>
                        </div>
                      </template>
                    </template>
                  </collapsible>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="showDetails == 'fittings'">
            <div
              class="row"
              v-for="fitting in selectedPartFittings[showDetailsCategory]"
              :key="fitting.id"
            >
              <div class="col col-12">
                <div class="card">
                  <h3 class="mb-xs">
                    {{ fitting.title }} |
                    {{
                      `${fitting.amount} ${
                        fitting.unit ||
                        __(
                          "jobs.components.fittings.list.common.fitting_unit_default"
                        )
                      }`
                    }}
                  </h3>

                  <ul
                    v-if="fitting.dimensions"
                    class="list-reset list-h job-parts__details__dimensions"
                  >
                    <li
                      v-for="(dimension, index) in fitting.dimensions"
                      :key="index"
                      class="mr-xl"
                    >
                      {{ dimension.extDesc || dimension.id }}<br />
                      {{
                        `${dimension.strValue || dimension.value} ${
                          dimension.unit ||
                          __(
                            "jobs.components.fittings.list.common.fitting_unit_default"
                          )
                        }`
                      }}
                    </li>
                  </ul>
                  <i v-else>Keine Dimensionen angegeben.</i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button
        v-if="bodyScrollLeft"
        class="scroll-left"
        @click="showDetails = null"
      >
        <img :src="icon('chevron.svg')" />
      </button>
    </div>
    <button
      :class="{
        'btn mt-mdsm rounded-circle btn-qr-icon btn-next': true,
      }"
      @click="scanCode"
    >
      <img :src="icon('qr-icon.svg')" />
    </button>
    <div v-if="scanedCode" class="qr-alerts">
      <span class="warning-arrow"></span>
      <div class="d-flex flex-column align-items-end">
        <div
          :class="{
            alert: true,
            'alert-warning': scanedCode,
            'alert-success': !scanedCode,
          }"
        >
          <span v-html="scanedCodeMessage"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JobViewBase from "./ViewBase";
import anime from "animejs";
import { toDate } from "smartdoors-shared/js/helpers/common";
import QrScannerWindow from "../../windows/QrScanner";
import LoadsImages from "../../mixins/LoadsImages";
import api from "../../helper/api";
import JobTechnicianMessagePart from "../../windows/JobTechnicianMessagePart";

export default {
  extends: JobViewBase,
  mixins: [LoadsImages],
  props: {
    partId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      scanedCode: false,
      scanedCodeMessage: "QR Code nicht vorhanden",
      floorSelected: null,
      partSelected: null,
      showDetails: null,
      showDetailsCategory: null,
      bodyScrollLeft: 0,
      iconArrow:
        '<svg width="0.8em" height="0.8em" viewBox="0 0 16 16" class="bi bi-arrow-down-up" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"/></svg>',
    };
  },
  computed: {
    preselectedPart() {
      let part = this.job
        ? this.job.parts.find((p) => p.id == this.partId)
        : null;
      this.partSelected = part;
      return part;
    },
    selectedPartFittings() {
      const fittings = {};

      for (const fitting of this.partSelected.fittings) {
        if (!(fitting.category in fittings)) {
          fittings[fitting.category] = [];
        }

        fittings[fitting.category].push(fitting);
      }

      return fittings;
    },

    selectedPartFiles() {
      let files = this.partSelected.location_files;
      for (const fitting of this.partSelected.fittings) {
        files = files.concat(fitting.files);
      }
      return files;
    },
    notizen() {
      let notizen = null;
      notizen = this.partSelected
        ? this.partSelected.location_position_desc
        : null;
      return notizen;
    },
    messages() {
      const messages = this.job.messages_technician;
      let filtredMessages = messages.filter((item) => {
        if (item.context_info["part"] !== undefined) {
          if (item.data.pictures && item.data.pictures.length > 0) {
            for (let i = 0; i < item.data.pictures.length; i++) {
              let picture = item.data.pictures[i];
              const pictureDownloadApiPath =
                this.config.api.urls.files.download + "/" + picture.route;
              Vue.set(picture, "path", null);
              ((pic) => {
                api.download(pictureDownloadApiPath).then((url) => {
                  Vue.set(pic, "path", url);
                });
              })(picture);
            }
            // return srcImg + "";
          }
          if (item.context_info.part.id === this.partSelected.id) return item;
        }
      });
      return filtredMessages;
    },
    // messages() {
    //   const messages = this.job.messages_technician;
    //   let filtredMessages = messages.filter((item) => {
    //     if (item.context_info["part"] !== undefined) {
    //       if (item.context_info.part.id === this.partSelected.id) return item;
    //     }
    //   });
    //   return filtredMessages;
    // },
  },
  watch: {
    bodyScrollLeft: function (scrollLeft) {
      anime({
        targets: this.$refs.body,
        scrollLeft: scrollLeft,
        easing: "linear",
        duration: 200,
      });
    },
  },
  created() {
    this.resizeListener = () => {
      if (this.$refs.body) {
        const scrollWidth =
          this.$refs.body.scrollWidth - this.$refs.body.clientWidth;

        if (this.bodyScrollLeft != scrollWidth) {
          this.bodyScrollLeft = scrollWidth;
        }
      }
    };
    window.addEventListener("resize", this.resizeListener);
  },
  updated() {
    this.resizeListener();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeListener);
  },
  methods: {
    async showJobTechnicianMessagesWindow($triggerEvent = null) {
      const message = await this.$windows.showWindow(
        JobTechnicianMessagePart,
        {
          title:
            this.__(`jobs.common.types.${this.job.typeName}`) +
            ` ${this.job.id_extern}`,
        },
        $triggerEvent ? $triggerEvent.target : null
      );
      if (message) {
        if (navigator.onLine) {
          this.app.isLoading = true;
        }
        await this.$store.dispatch("jobs/sendCommonTechnicianMessage", {
          id: this.job.id,
          part_id: this.partId,
          message,
        });
        this.app.isLoading = false;
      }
    },
    dateOutput(dateString) {
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      const date = toDate(dateString);

      return (
        date.toLocaleDateString(undefined, options) +
        " (" +
        date.toLocaleTimeString(undefined, {
          hour: "2-digit",
          minute: "2-digit",
        }) +
        ")"
      );
    },
    async doJobPart(id = null, partId = null) {
      const partRoute = {
        name: "JobPart",
        params: { jobId: id, partId: partId, loadJobFromApi: true },
      };
      this.$router.push(partRoute);
    },
    async doJobScan(job_id, id = null) {
      let paramId = {};
      if (id) {
        paramId = { partID: id };
      }
      const reportRoute = {
        name: "JobParts",
        params: { jobId: job_id, loadJobFromApi: true },
        query: paramId,
      };

      this.app.isLoading = true;
      await this.jobDataLoading;
      this.app.isLoading = false;

      this.$router.push(reportRoute);
    },
    async scanCode($triggerEvent = null) {
      this.loadPart = true;
      this.scanedCode = false;
      this.scanedCodeMessage = "QR Code nicht vorhanden";
      const result = await this.$windows.showWindow(
        QrScannerWindow,
        $triggerEvent ? $triggerEvent.target : null
      );
      if (result) {
        const code = await this.$store.dispatch("jobs/respondQrCodeRequests", {
          code: result.code,
        });
        if (code.data) {
          this.loadPart = false;
          if (code.data.status && code.data.status == 1) {
            if (code.data.myJob) {
              this.doJobPart(code.data.job_id, code.data.part_id);
            } else {
              this.scanedCode = true;
              const manager = code.data.jobs.manager.name;

              this.scanedCodeMessage =
                "Sie besitzen keine Zugriffsrechte auf dieses laufendes Projekt. Projekt <b>" +
                code.data.jobs.id_extern +
                "</b> wird durch <b>" +
                manager +
                "</b> verwaltet.";
            }
          } else {
            this.doJobScan(code.data.job_id, code.data.part_id);
          }
          // this.doJobPart(code.data.job_id, code.data.part_id);
        } else {
          // location.reload();
          this.scanedCode = true;
        }
      }
    },
  },
};
</script>

<style lang="scss">
.btn-qr-icon {
  width: 64px;
  height: 64px;
  display: block;
  padding: 12px;
  min-width: auto;
  position: fixed;
  right: 20px;
  bottom: 20px;
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
.job-parts__body {
  .job-parts__details {
    ul {
      padding-left: 20px !important;
      list-style: disc;
      list-style-position: outside;
    }
  }
}

.qr-alerts {
  position: fixed;
  bottom: 30px;
  right: 90px;
  .warning-arrow {
    width: 10px;
    height: 10px;
    background: #ff9956;
    position: absolute;
    top: 50%;
    right: -4px;
    z-index: -1;
    transform: translate(00%, -50%);
    clip-path: polygon(50% 0%, 100% 50%, 50% 100%);
  }
}
.job-parts {
  h2 {
    font-size: map-get($font-sizes, sm);
    font-weight: map-get($font-weights, regular);
    color: $bg-dark;
  }

  i {
    color: $bg-dark;
  }

  .card {
    padding-left: map-get($spacers, sm);
    padding-right: map-get($spacers, sm);
    height: 100%;
  }
  .title-sec {
    color: #111;
    font-size: 0.8rem;
  }
  &__head {
    justify-content: space-between;

    &__adr {
      font-weight: map-get($font-weights, medium);
      font-size: map-get($font-sizes, md);
    }

    &__buttons {
      flex: 0 1 auto;
    }
  }

  &__main {
    position: relative;

    button.scroll-left {
      position: absolute;
      left: map-get($spacers, md);
      top: 0;
      background-color: $white;
      border: 1px solid $black;
      border-radius: 50%;
      padding: 8px;
      line-height: 0;
      transform: rotate(180deg);
      img {
        padding-left: 3px;
        padding-right: 1px;
      }
    }
  }

  &__body {
    justify-content: flex-start;
    flex-wrap: nowrap;
    overflow: hidden;

    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      border-radius: 6px;
      overflow: auto;
      li {
        button {
          border-bottom: 1px solid #dbdbdb;
        }
        &:last-child {
          // border-bottom: 1px solid white;
          button {
            border-bottom: none;
          }
        }
      }
      button {
        padding: 1rem map-get($spacers, mdsm);
        width: 100%;
        text-align: left;
        display: flex;
        justify-content: space-between;
        margin: 0 !important;

        > div {
          flex: 1 0 auto;
          text-align: right;
          // padding-right: map-get($spacers, mdsm);
          padding-right: 0;

          > img {
            margin-left: map-get($spacers, sm);
          }
        }

        &::after {
          content: url("~smartdoors-shared/img/icons/chevron.svg");
          flex: 0 1 auto;
          margin-left: map-get($spacers, mdsm);
        }
        &:not(.btn-next) {
          background-color: $white;
          margin: map-get($spacers, xs);
        }

        &:hover,
        &.active {
          &:not(:disabled) {
            background-color: $accent1;
            color: $white;

            &::after {
              content: url("~smartdoors-shared/img/icons/chevron-white.svg");
            }
          }
        }
      }
    }

    > div {
      min-width: 190px;

      &.job-parts__buttons {
        min-width: 230px;
        ul li:nth-last-of-type(-n + 2) button {
          border: none;
        }
      }
      &.job-parts__details {
        flex: 1 0 570px;
        min-width: 570px;
      }
    }
  }

  &__details {
    @include set-gutter-spacing(map-get($spacers, mdsm));
  }
}
.hide-collapse-btn {
  .collapsible__buttons {
    display: none;
  }
}
.sub-table {
  font-size: 12px;
  td {
    font-weight: 100;
  }
}
.th-items {
  background-color: black;
  color: white;

  th {
    text-align: inherit;
    border: 1px solid white;
    &:hover {
      cursor: pointer;
    }
    span {
      float: right;
    }
  }
}
.white-bg {
  background: $white;
}
table th,
td {
  padding: 0 10px;
}
table tbody tr:nth-child(even) {
  background-color: #f2f2f2;
  border-top: 1px solid #929191;
  border-bottom: 1px solid #929191;
}
</style>